export function isOfEnum(value, e) {
    return Object.values(e).includes(value);
}
